import { type Control, type FieldValues, type Path, useController } from 'react-hook-form';
import Input from '~/components2/forms/Input';

export interface FieldProps<T extends FieldValues = FieldValues> {
  id: Path<T>;
  label: string;
  control: Control<T>;
  rules?: { [key: string]: any };
  placeholder?: string;
  type?: 'string' | 'number' | 'email';
  tooltipText?: string;
}

export default function Field<T extends FieldValues>({
  id,
  label,
  control,
  rules: additionalRules,
  placeholder,
  type = 'string',
  tooltipText,
}: FieldProps<T>) {
  let rules = {
    required: `${label} is required`,
  };

  if (additionalRules) {
    rules = {
      ...rules,
      ...additionalRules,
    };
  }

  const {
    field,
    fieldState: { error },
  } = useController({ name: id, control, rules: { ...rules } });

  return (
    <Input
      {...field}
      label={label}
      error={error?.message}
      placeholder={placeholder}
      type={type}
      tooltipText={tooltipText}
    />
  );
}
